import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowUpRightFromSquare } from '@fortawesome/free-solid-svg-icons';
import { motion, useReducedMotion } from 'framer-motion';
import './StemAccreditationSection.css';

const BADGE = '/assets/img/hero/stem-accredited.png';
const BADGE_LIGHT = '/assets/img/hero/stem-accredited-lightmode.png'; // used inside light mode (Trial Dashboard)
const VERIFY_URL = 'https://blockchain.stem.org/fa3514bb-439a-4ce8-a44e-56a2ed4947db#acc.Z4myOMLG';

const StemAccreditationSection = () => {
  const reduceMotion = useReducedMotion();
  const reveal = reduceMotion
    ? {}
    : {
        initial: { opacity: 0, y: 16 },
        whileInView: { opacity: 1, y: 0 },
        transition: { duration: 0.5 },
        viewport: { once: true, margin: '-60px' },
      };

  return (
    <section className="rmacc" aria-label="STEM.org accreditation">
      <div className="rmacc-inner">
        <motion.div className="rmacc-card" {...reveal}>
          <img src={BADGE} alt="STEM.org Accredited Educational Experience" className="rmacc-badge rmacc-badge--dark" loading="lazy" />
          <img src={BADGE_LIGHT} alt="STEM.org Accredited Educational Experience" className="rmacc-badge rmacc-badge--light" loading="lazy" />

          <div className="rmacc-copy">
            <h2 className="rmacc-title">
              Accredited by <span>STEM.org</span>
            </h2>
            <p className="rmacc-text">
              Our curriculum and teaching are reviewed and accredited as a STEM.org Accredited Educational
              Experience. You can verify it yourself.
            </p>
          </div>

          <a href={VERIFY_URL} target="_blank" rel="noopener noreferrer" className="rmacc-link">
            Verify accreditation
            <FontAwesomeIcon icon={faArrowUpRightFromSquare} />
          </a>
        </motion.div>
      </div>
    </section>
  );
};

export default StemAccreditationSection;